module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.list != '') ? _c('div', {
    attrs: {
      "id": "situation"
    }
  }, [_c('div', {
    staticClass: "logo"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', _vm._l((_vm.list), function(item, index) {
    return _c('li', {
      key: index
    }, [_c('img', {
      staticClass: "head",
      attrs: {
        "src": item.avatar,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.nickname))]), _vm._v(" "), (item.type != 6) ? _c('img', {
      staticClass: "img_vip",
      attrs: {
        "src": "http://shared.youdao.com/dict/market/oxford-activity/imgs/oneVip.png",
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (item.type == 6) ? _c('img', {
      staticClass: "img_vip",
      attrs: {
        "src": "http://shared.youdao.com/dict/market/oxford-activity/imgs/sixVip.png",
        "alt": ""
      }
    }) : _vm._e()])
  }))])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "title"
  }, [_c('span'), _vm._v("好友领取情况"), _c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-222d5d75","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/GetedNumber.vue
// module id = 139
// module chunks = 1